
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.75 7.25h-5v-5A.269.269 0 008.5 2h-1a.246.246 0 00-.25.25v5h-5A.246.246 0 002 7.5v1c0 .156.094.25.25.25h5v5c0 .156.094.25.25.25h1c.125 0 .25-.094.25-.25v-5h5c.125 0 .25-.094.25-.25v-1a.269.269 0 00-.25-.25z","fill":"#0093B8"}})])
          )
        }
      }
    